/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/JumpRateModelV2.json';
import { JumpRateModelV2 } from 'libs/contracts/generated/infos/contractTypes';
import { useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetJumpRateModelV2ContractInput {
  address: string;
  signerOrProvider: Signer | Provider;
}

export const getJumpRateModelV2Contract = ({
  signerOrProvider,
  address,
}: GetJumpRateModelV2ContractInput) =>
  new Contract(address, abi, signerOrProvider) as JumpRateModelV2;

interface UseGetJumpRateModelV2ContractInput {
  passSigner: boolean;
  address: string;
  chainId?: ChainId;
}

export const useGetJumpRateModelV2Contract = ({
  passSigner = false,
  address,
  chainId,
}: UseGetJumpRateModelV2ContractInput) => {
  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getJumpRateModelV2Contract({
            address,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, address],
  );
};
